import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import State from 'store/State';
import { IndexMapping, initialIndexMappingsState } from './IndexMappingsState';

const indexMappingsSlice = createSlice({
    name: 'indexMappings',
    initialState: initialIndexMappingsState,
    reducers: {
        setMappings: (
            state,
            payload: PayloadAction<{
                symbology: SymbologyValues;
                mappings: IndexMapping[];
            }>
        ) => {
            const { mappings, symbology } = payload.payload;
            state[symbology] = mappings;
        },
        removeMappings: (
            state,
            payload: PayloadAction<{
                symbology: SymbologyValues;
            }>
        ) => {
            const { symbology } = payload.payload;
            delete state[symbology];
        },
    },
});

export const actions = indexMappingsSlice.actions;

export const selectIndexMappingsState = (state: State) => state.indexMappings;

export const selectIndexMappingsInSymbology: (
    state: State,
    symbology: SymbologyValues
) => IndexMapping[] | undefined = (state, symbology) =>
    selectIndexMappingsState(state)[symbology];

export default indexMappingsSlice.reducer;
